// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectGoogleAuthResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_ADD_2FA_RESPONSE);
        this.Secret2FAKey = null;
        this.QRCode = null; // PNG picture as byte code
        this.FileFormat = null;
    }
}
